"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentNotificationsInbox = void 0;
// resources/js/Students/StudentNotificationsInbox.tsx
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var MarkEmailRead_1 = __importDefault(require("@mui/icons-material/MarkEmailRead"));
var MarkEmailUnread_1 = __importDefault(require("@mui/icons-material/MarkEmailUnread"));
var Notifications_1 = __importDefault(require("@mui/icons-material/Notifications"));
var Lang_js_1 = require("../../Lang.js");
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var MarkEmailReadOutlined_1 = __importDefault(require("@mui/icons-material/MarkEmailReadOutlined"));
var MarkEmailUnreadOutlined_1 = __importDefault(require("@mui/icons-material/MarkEmailUnreadOutlined"));
var NotificationPreferenceControls_1 = __importDefault(require("./NotificationPreferenceControls"));
var notificationsStore_1 = require("../storage/notificationsStore");
var api_1 = require("../api");
var timestamps_1 = require("../../../utils/timestamps");
function decodeHtml(str) {
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
}
var StudentNotificationsInbox = function (_a) {
    var _b, _c, _d;
    var notifications = _a.notifications, filteredNotifications = _a.filteredNotifications, selectedNotification = _a.selectedNotification, unreadCount = _a.unreadCount, filter = _a.filter, query = _a.query, hasMore = _a.hasMore, isLoadingMore = _a.isLoadingMore, setFilter = _a.setFilter, setQuery = _a.setQuery, setSelectedId = _a.setSelectedId, loadMore = _a.loadMore, markRead = _a.markRead, markAllRead = _a.markAllRead, markUnread = _a.markUnread, archive = _a.archive, restore = _a.restore;
    var canShowArchivedTab = true;
    var visibleUnreadCount = (0, react_1.useMemo)(function () {
        return filteredNotifications.filter(function (n) { return !n.read_at && !n.archived_at; }).length;
    }, [filteredNotifications]);
    var handleMarkAllRead = function () {
        var ids = filteredNotifications
            .filter(function (n) { return !n.read_at && !n.archived_at; })
            .map(function (n) { return n.id; });
        if (ids.length > 0)
            void markAllRead(ids);
    };
    var renderChannelChip = function () { return (react_1.default.createElement(material_1.Chip, { size: "small", icon: react_1.default.createElement(Notifications_1.default, null), label: (0, Lang_js_1.__)('Web'), variant: "outlined", sx: {
            '& .MuiChip-icon': { mr: 0.5 },
        } })); };
    var bodyRef = (0, react_1.useRef)(null);
    var listRef = (0, react_1.useRef)(null);
    var sentinelRef = (0, react_1.useRef)(null);
    (0, react_1.useLayoutEffect)(function () {
        var el = bodyRef.current;
        if (!el)
            return;
        (0, timestamps_1.renderLocalTimestamps)(el, { showTime: false });
    }, [selectedNotification === null || selectedNotification === void 0 ? void 0 : selectedNotification.data.body]);
    // Infinite scroll: observe the sentinel element inside the scrollable list pane.
    (0, react_1.useEffect)(function () {
        var sentinel = sentinelRef.current;
        var container = listRef.current;
        if (!sentinel || !container)
            return;
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting && hasMore && !isLoadingMore) {
                loadMore();
            }
        }, { root: container, threshold: 0 });
        observer.observe(sentinel);
        return function () { return observer.disconnect(); };
    }, [hasMore, isLoadingMore, loadMore]);
    return (react_1.default.createElement(material_1.Box, { sx: {
            display: 'flex',
            height: '100%',
            minHeight: 500,
            borderRadius: 2,
            overflow: 'hidden',
            bgcolor: 'background.paper',
            boxShadow: 1,
        } },
        react_1.default.createElement(material_1.Box, { sx: { flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 } },
            react_1.default.createElement(material_1.Box, { sx: {
                    p: 2,
                    borderBottom: 1,
                    borderColor: 'divider',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    alignItems: 'center',
                } },
                react_1.default.createElement(material_1.ToggleButtonGroup, { size: "small", exclusive: true, value: filter, onChange: function (_, next) { return next && setFilter(next); } },
                    react_1.default.createElement(material_1.ToggleButton, { value: "all" },
                        (0, Lang_js_1.__)('Inbox'),
                        unreadCount > 0 && (react_1.default.createElement(material_1.Box, { component: "span", sx: {
                                ml: 1,
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minWidth: 20,
                                height: 20,
                                borderRadius: '10px',
                                bgcolor: 'primary.main',
                                color: 'primary.contrastText',
                                fontSize: '0.7rem',
                                fontWeight: 700,
                                px: 0.5,
                                lineHeight: 1,
                            } }, unreadCount > 99 ? '99+' : unreadCount))),
                    react_1.default.createElement(material_1.ToggleButton, { value: "unread" }, (0, Lang_js_1.__)('Unread')),
                    canShowArchivedTab && react_1.default.createElement(material_1.ToggleButton, { value: "archived" }, (0, Lang_js_1.__)('Archived'))),
                react_1.default.createElement(material_1.Button, { size: "small", variant: "outlined", startIcon: react_1.default.createElement(MarkEmailRead_1.default, null), disabled: visibleUnreadCount === 0, onClick: handleMarkAllRead }, (0, Lang_js_1.__)('Mark all read')),
                react_1.default.createElement(material_1.Box, { sx: { flexGrow: 1 } }),
                react_1.default.createElement(material_1.TextField, { size: "small", variant: "outlined", placeholder: (0, Lang_js_1.__)('Search messages'), value: query, onChange: function (e) { return setQuery(e.target.value); } })),
            react_1.default.createElement(material_1.Box, { sx: { flex: 1, display: 'flex', minHeight: 0 } },
                react_1.default.createElement(material_1.Box, { ref: listRef, sx: {
                        width: 360,
                        borderRight: 1,
                        borderColor: 'divider',
                        overflowY: 'auto',
                        minHeight: 0,
                    } },
                    filteredNotifications.length === 0 ? (react_1.default.createElement(material_1.Box, { sx: { p: 3 } },
                        react_1.default.createElement(material_1.Typography, { variant: "body1" },
                            filter === 'unread' && (0, Lang_js_1.__)("You're all caught up!"),
                            filter === 'archived' && (0, Lang_js_1.__)('No archived messages.'),
                            filter === 'all' && (0, Lang_js_1.__)('No messages in your inbox.')))) : (react_1.default.createElement(material_1.List, { disablePadding: true }, filteredNotifications.map(function (n) {
                        var isRead = !!n.read_at;
                        return (react_1.default.createElement(react_1.default.Fragment, { key: n.id },
                            react_1.default.createElement(material_1.ListItem, { disablePadding: true, className: [
                                    'msia-notifications__item',
                                    !isRead
                                        ? 'msia-notifications__item--unread'
                                        : 'msia-notifications__item--read',
                                    n.id === (selectedNotification === null || selectedNotification === void 0 ? void 0 : selectedNotification.id)
                                        ? 'msia-notifications__item--selected'
                                        : '',
                                ]
                                    .filter(Boolean)
                                    .join(' ') },
                                react_1.default.createElement(material_1.ListItemButton, { selected: n.id === (selectedNotification === null || selectedNotification === void 0 ? void 0 : selectedNotification.id), className: "msia-notifications__itemButton", sx: {
                                        position: 'relative',
                                        alignItems: 'flex-start',
                                        py: 1.5,
                                        '&:hover .msia-notifications__rowActions': { opacity: 1 },
                                    }, onClick: function () { return setSelectedId(n.id); } },
                                    !isRead && (react_1.default.createElement(material_1.Box, { sx: {
                                            position: 'absolute',
                                            top: 8,
                                            right: 8,
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            bgcolor: 'secondary.main',
                                            zIndex: 1,
                                            pointerEvents: 'none',
                                        } })),
                                    react_1.default.createElement(material_1.ListItemText, { primary: react_1.default.createElement(material_1.Stack, { direction: "row", spacing: 1, alignItems: "center" },
                                            react_1.default.createElement(material_1.Typography, { variant: "subtitle1", component: "span", sx: { fontWeight: !isRead ? 700 : 500 } }, decodeHtml(n.data.title)),
                                            n.archived_at && (react_1.default.createElement(material_1.Chip, { size: "small", label: (0, Lang_js_1.__)('Archived'), variant: "outlined", sx: { ml: 0.5 } }))), secondary: react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement(material_1.Typography, { variant: "body2", component: "span", color: "text.secondary", sx: {
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    opacity: isRead ? 0.72 : 1,
                                                } },
                                                n.data.body.split(/<\/?[^>]+(>|$)/)[0],
                                                " ..."),
                                            react_1.default.createElement(material_1.Box, { sx: {
                                                    mt: 0.75,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                } },
                                                react_1.default.createElement(Tooltip_1.default, { title: "".concat((0, Lang_js_1.__)('All times shown in'), " ").concat((0, timestamps_1.getLocalTimeZoneString)("long"), " (").concat((0, timestamps_1.getLocalTimeZoneString)("short"), ") ").concat((0, Lang_js_1.__)('based on your browser settings.')), placement: "top" },
                                                    react_1.default.createElement(material_1.Typography, { variant: "caption", component: "span", color: "text.secondary" },
                                                        (0, timestamps_1.formatTimestamp)(Date.parse(n.created_at)),
                                                        " (",
                                                        (0, timestamps_1.getLocalTimeZoneString)(),
                                                        ")")),
                                                react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 } },
                                                    react_1.default.createElement(material_1.Box, { className: "msia-notifications__rowActions", sx: {
                                                            display: 'flex',
                                                            gap: 0.5,
                                                            opacity: 0,
                                                            transition: 'opacity 120ms',
                                                        } }, !isRead ? (react_1.default.createElement(Tooltip_1.default, { title: (0, Lang_js_1.__)('Mark as read') },
                                                        react_1.default.createElement(IconButton_1.default, { size: "small", onClick: function (e) {
                                                                e.stopPropagation();
                                                                markRead(n.id);
                                                            } },
                                                            react_1.default.createElement(MarkEmailReadOutlined_1.default, { fontSize: "small" })))) : (react_1.default.createElement(Tooltip_1.default, { title: (0, Lang_js_1.__)('Mark as unread') },
                                                        react_1.default.createElement(IconButton_1.default, { size: "small", onClick: function (e) {
                                                                e.stopPropagation();
                                                                markUnread(n.id);
                                                            } },
                                                            react_1.default.createElement(MarkEmailUnreadOutlined_1.default, { fontSize: "small" })))))))), secondaryTypographyProps: {
                                            component: 'div',
                                        } }))),
                            react_1.default.createElement(material_1.Divider, { component: "li" })));
                    }))),
                    react_1.default.createElement(material_1.Box, { ref: sentinelRef, sx: { height: 1 } }),
                    isLoadingMore && (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'center', py: 2 } },
                        react_1.default.createElement(material_1.CircularProgress, { size: 20 })))),
                react_1.default.createElement(material_1.Box, { sx: { flex: 1, minWidth: 0, minHeight: 0, display: 'flex' } }, selectedNotification ? (react_1.default.createElement(material_1.Paper, { square: true, elevation: 0, sx: {
                        flex: 1,
                        minWidth: 0,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                    } },
                    react_1.default.createElement(material_1.Box, { sx: {
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                            bgcolor: 'background.paper',
                            borderBottom: 1,
                            borderColor: 'divider',
                            px: 3,
                            py: 2,
                        } },
                        react_1.default.createElement(material_1.Stack, { direction: "row", spacing: 2, alignItems: "flex-start", className: "msia-stack" },
                            react_1.default.createElement(material_1.Box, { sx: { flex: 1, minWidth: 0 } },
                                react_1.default.createElement(material_1.Typography, { variant: "h6", sx: { fontWeight: 600 } }, decodeHtml(selectedNotification.data.title)),
                                react_1.default.createElement(material_1.Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { mt: 0.5 }, className: "msia-stack" },
                                    react_1.default.createElement(Tooltip_1.default, { title: "".concat((0, Lang_js_1.__)('All times shown in'), " ").concat((0, timestamps_1.getLocalTimeZoneString)("long"), " (").concat((0, timestamps_1.getLocalTimeZoneString)("short"), ") ").concat((0, Lang_js_1.__)('based on your browser settings.')), placement: "top" },
                                        react_1.default.createElement(material_1.Typography, { variant: "caption", component: "span", color: "text.secondary" },
                                            (0, timestamps_1.formatTimestamp)(Date.parse(selectedNotification.created_at)),
                                            " (",
                                            (0, timestamps_1.getLocalTimeZoneString)(),
                                            ")")),
                                    renderChannelChip())),
                            react_1.default.createElement(material_1.Stack, { className: "msia-stack", direction: "row", spacing: 1, sx: { flexShrink: 0 } },
                                !selectedNotification.read_at ? (react_1.default.createElement(material_1.Button, { variant: "contained", size: "small", startIcon: react_1.default.createElement(MarkEmailRead_1.default, null), onClick: function () { return markRead(selectedNotification.id); } }, (0, Lang_js_1.__)('Mark as read'))) : (react_1.default.createElement(material_1.Button, { variant: "outlined", size: "small", startIcon: react_1.default.createElement(MarkEmailUnread_1.default, null), onClick: function () { return markUnread(selectedNotification.id); } }, (0, Lang_js_1.__)('Mark as unread'))),
                                !selectedNotification.archived_at ? (react_1.default.createElement(material_1.Button, { variant: "text", size: "small", onClick: function () { return archive(selectedNotification.id); } }, (0, Lang_js_1.__)('Archive'))) : (react_1.default.createElement(material_1.Button, { variant: "text", size: "small", onClick: function () { return restore(selectedNotification.id); } }, (0, Lang_js_1.__)('Move to inbox')))))),
                    react_1.default.createElement(material_1.Box, { sx: {
                            flex: 1,
                            minHeight: 0,
                            overflowY: 'auto',
                            px: 3,
                            py: 3,
                        } },
                        react_1.default.createElement(material_1.Typography, { variant: "body1", sx: { whiteSpace: 'pre-line', mb: ((_b = selectedNotification.data.permalinks) === null || _b === void 0 ? void 0 : _b.web) && selectedNotification.data.permalinks.web !== '/app/notifications' ? 2 : 4 } },
                            react_1.default.createElement("span", { ref: bodyRef, dangerouslySetInnerHTML: { __html: selectedNotification.data.body }, onClick: function (e) {
                                    if (e.target.closest('a')) {
                                        void (0, api_1.markClicked)([selectedNotification.id]);
                                    }
                                } })),
                        ((_c = selectedNotification.data.permalinks) === null || _c === void 0 ? void 0 : _c.web) && selectedNotification.data.permalinks.web !== '/app/notifications' && (react_1.default.createElement(material_1.Box, { sx: { mb: 4 } },
                            react_1.default.createElement(material_1.Button, { variant: "contained", size: "small", component: "a", href: selectedNotification.data.permalinks.web, target: "_blank", rel: "noopener noreferrer", onClick: function () { return void (0, api_1.markClicked)([selectedNotification.id]); } }, selectedNotification.data.button_text || (0, Lang_js_1.__)('Click here')))),
                        react_1.default.createElement(material_1.Box, { sx: {
                                mt: 6,
                                pt: 3,
                                px: 2,
                                pb: 2,
                                borderTop: 1,
                                borderColor: 'divider',
                                bgcolor: 'grey.50',
                                borderRadius: 1,
                            } },
                            react_1.default.createElement(NotificationPreferenceControls_1.default, { userId: (_d = (0, notificationsStore_1.getUserId)()) !== null && _d !== void 0 ? _d : 0, kind: selectedNotification.data.kind }))))) : (react_1.default.createElement(material_1.Box, { sx: {
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        textAlign: 'center',
                        color: 'text.secondary',
                        px: 4,
                    } },
                    react_1.default.createElement(Notifications_1.default, { sx: { fontSize: 48, mb: 2, opacity: 0.4 } }),
                    react_1.default.createElement(material_1.Typography, { variant: "h6", gutterBottom: true }, (0, Lang_js_1.__)('Select a message to read')),
                    react_1.default.createElement(material_1.Typography, { variant: "body2" }, (0, Lang_js_1.__)('Choose a notification from the list to view details and manage preferences.')))))))));
};
exports.StudentNotificationsInbox = StudentNotificationsInbox;
exports.default = exports.StudentNotificationsInbox;
